module.exports = __webpack_public_path__ + "img/sk-partners-tasr.81e00ea4.png";